function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
export default (({
  styles = {},
  ...props
}) => React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 16 16"
}, props), React.createElement("path", {
  d: "M15 0a1 1 0 011 1v14a1 1 0 01-1 1h-2a1 1 0 01-1-1V1a1 1 0 011-1h2zM3 11.63a1 1 0 011 1V15a1 1 0 01-1 1H1a1 1 0 01-1-1v-2.37a1 1 0 011-1h2zM9 5a1 1 0 011 1v9a1 1 0 01-1 1H7a1 1 0 01-1-1V6a1 1 0 011-1h2z"
})));